<div class="table-container">

  <table mat-table matSort #ownerdeviceslisttable class="simple-table">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef i18n="@@devicelist_name">Nome</th>

      <td mat-cell *matCellDef="let element">

        <!-- <ng-container *ngIf="element.systemInfo.reference">{{ element.systemInfo.reference }}</ng-container>
        <ng-container *ngIf="!element.systemInfo.reference || element.systemInfo.name == '' "
          i18n="@@devicelist_device_without_name">Dispositivo senza nome</ng-container> -->
        <ng-container>{{ element.name }}</ng-container>

      </td>

    </ng-container>

    <ng-container matColumnDef="serial">
      <th mat-header-cell *matHeaderCellDef i18n="@@devicelist_serial">Seriale</th>
      <td mat-cell *matCellDef="let element"> {{ element.serial }} </td>
    </ng-container>

    <ng-container matColumnDef="version">
      <th mat-header-cell *matHeaderCellDef i18n="@@devicelist_type">Versione</th>
      <td mat-cell *matCellDef="let element">
        {{ element.systemInfo.version }}
        <fa-icon icon="chevron-right" class="float-right padding-5"></fa-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"
      [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
    </tr>

  </table>

</div>

<app-loading-screen #ownerdeviceslistloader></app-loading-screen>
